var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-cell',{staticClass:"header",attrs:{"title":_vm.title,"title-class":"title","value":_vm.value,"value-class":"value","center":""}})}
var staticRenderFns = []

export { render, staticRenderFns }